exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loading-shroud{height:100%;background-color:#fff;opacity:1;position:absolute;top:0;right:0;left:0;bottom:0;z-index:10;text-align:center;pointer-events:none;transition:opacity .6s}.loading-shroud img{width:50px;margin-top:240px}.loading .loading-shroud{opacity:.9;pointer-events:auto}.app-content{z-index:5;position:relative}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader?modules&localIdentName=[name]---[local]---[hash:base64:5]!./client/styles/loading.styl
// module id = 1350
// module chunks = 0